// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__32uZp","root--primary":"Button_root--primary__1PgJ7","root--danger":"Button_root--danger__2qOdm"};